module.exports = __webpack_public_path__ + "static/media/icon-call.d310e64c.svg";